import { Component } from '@angular/core';
import { BaseMortgageApplicationComponent } from '../../../pages/base-mortgage-application.component';
import { MortgageApplicationStore } from './../../../services/mortgage-application-store';

@Component({
  selector: 'boi-your-outgoings-declaration',
  templateUrl: './your-outgoings-declaration.component.html',
  styleUrls: ['./your-outgoings-declaration.component.scss']
})
export class YourOutgoingsDeclarationComponent extends BaseMortgageApplicationComponent {
  constructor(protected mortgageApplicationStore: MortgageApplicationStore) {
    super(mortgageApplicationStore);
  }
}
